module.exports = __webpack_public_path__ + "img/tips.6e8daa61.png";